import { render } from "./RegisterSuccess.vue?vue&type=template&id=2b84f0ae&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"

import "./custom-confirm-email.scss?vue&type=style&index=0&id=2b84f0ae&lang=scss&scoped=true"
import "./RegisterSuccess.vue?vue&type=style&index=1&id=2b84f0ae&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b84f0ae"]])

export default __exports__